const getters = {
  getPolicies: (state) => state.policies,
  getPolicy: (state) => state.policy,
  getClaims: (state) => state.claims,
  getClaim: (state) => state.claim,
  getPoliciesMeta: (state) => state.policiesMeta,
  getClaimsMeta: (state) => state.claimsMeta,
  getClaimsHistoriesClaim: (state) => state.claimsHistoriesClaim,
  getPartners: (state) => state.partners,
  getProducts: (state) => state.products,
  getProductCategories: (state) => state.productCategories,
  getUploadProgress: (state) => state.uploadProgress,
  getCreatePolicy: (state) => state.createPolicy,
  getProductService: (state) => state.productService,
  getProductServiceBuybackProgram: (state) =>
    state.productServiceBuybackProgram,
  getListBrand: (state) => state.listBrand,
  getListType: (state) => state.listType,
  getCreateClaim: (state) => state.createClaim,
  getIsValidCreateClaim: (state) => state.isValidCreateClaim,
  getQuestionCostEstimation: (state) => state.questionCostEstimation,
  getFilesCostEstimation: (state) => state.filesCostEstimation,
  getExtractImei: (state) => state.extractImei,
  getTemplateUrl: (state) => state.templateUrl,
};

export default getters;
